module.exports = __webpack_public_path__ + "img/Peru.197e774f.svg";